import { useStandardsModalFooter } from "./useStandardsModalFooter";

export { useStandardsModalFooter };
